import React from 'react';

interface PanelProps {
  title: string;
  subtitle?: string;
  showSubtitle?: boolean;
  children: React.ReactNode;
  className?: string;
  actionComponent?: React.ReactNode;
}

/**
 * Standardized panel component based on Figma design system
 * Provides consistent styling for white content blocks with headers
 */
export const Panel: React.FC<PanelProps> = ({
  title,
  subtitle,
  showSubtitle = true,
  children,
  className = '',
  actionComponent
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-sm ${className}`}>
      <div className="px-6 py-[13px]">
        <div className="flex items-center justify-between mb-2">
          <div className="inline-grid grid-cols-[max-content] grid-rows-[max-content] place-items-start text-[#262628] text-left">
            {showSubtitle && subtitle && (
              <div 
                className="[grid-area:1_/_1] font-normal text-[9px] h-[13px] mt-[25px] w-56"
                style={{ fontFamily: 'Open Sans, sans-serif' }}
              >
                {subtitle}
              </div>
            )}
            <h3 
              className="[grid-area:1_/_1] font-bold text-[19px] h-[23px] w-full mb-5"
              style={{ fontFamily: 'Open Sans, sans-serif' }}
            >
              {title}
            </h3>
          </div>
          
          {actionComponent && (
            <div className="ml-2">
              {actionComponent}
            </div>
          )}
        </div>
        <div className="mt-2.5">
          {children}
        </div>
      </div>
    </div>
  );
};